/**
 * Quiet Authority Recharts tooltip — replaces the stock white-box default,
 * which was the one visibly un-themed surface on the dashboard. Paper
 * background, hairline border, the warm float shadow, mono tabular figures and
 * an eyebrow-style label.
 *
 * Passed to a Recharts <Tooltip content={<QAChartTooltip ... />} />. Recharts
 * clones the element with { active, payload, label }; any extra props set on
 * the element (e.g. valueFormat) are preserved through the clone.
 */
interface TooltipEntry {
  name?: string;
  value?: number | string;
  color?: string;
  dataKey?: string | number;
  payload?: Record<string, unknown>;
}

export function QAChartTooltip({
  active,
  payload,
  label,
  valueFormat,
}: {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string | number;
  valueFormat?: (value: number | string, entry: TooltipEntry) => string;
}) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="qa-card qa-shadow px-3 py-2 text-xs">
      {label != null && label !== '' && <p className="qa-eyebrow mb-1.5">{String(label)}</p>}
      <div className="space-y-1">
        {payload.map((entry, i) => (
          <div key={i} className="flex items-center gap-3 qa-mono">
            <span
              className="inline-block w-2 h-2 shrink-0"
              style={{ background: entry.color ?? 'var(--qa-rust)' }}
            />
            <span className="text-ink-mute">{entry.name ?? '—'}</span>
            <span className="text-ink ml-auto">
              {valueFormat && entry.value != null
                ? valueFormat(entry.value, entry)
                : String(entry.value ?? '')}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
